import Vue from 'vue'

export default {
  listarEditorialPublicado: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
            listarEditorial(publicado: S, ativa: S){
              id
              titulo
              descricao
              data
              ativa
              publicado
              autor{
                id
                nome
                foto
              }
              data_publicacao
              quantidadeCurtidas
              quantidadeVisualizacao
              publicacaoPrincipal{
                midia{
                  id
                  type
                  video_url
                  link_url
                  cor_fundo
                  tipo_midia{
                    id
                    descricao
                    largura
                    altura
                    formato
                  }
                  imagem
                }
              }
            }
          }`
      }
    })
  },
  listarEditorialNaoPublicado: () => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
            listarEditorial(publicado: N, ativa: S){
              id
              titulo
              descricao
              data
              ativa
              publicado
              autor{
                id
                nome
                foto
              }
              data_publicacao
            }
          }`
      }
    })
  },
  listarEditorialByAutor: (autor_id) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
            listarEditorial(autor_id: ${autor_id}, ativa: S){
              id
              titulo
              descricao
              data
              ativa
              publicado
              autor{
                id
                nome
                foto
              }
              data_publicacao
            }
          }`
      }
    })
  },
  listarEditorialByData: (data) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `{
            listarEditorial(data: "${data}", ativa: S){
              id
              titulo
              descricao
              data
              ativa
              publicado
              autor{
                id
                nome
                foto
              }
              data_publicacao
            }
          }`
      }
    })
  },
  criarEditorial: (editorialInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          criarEditorial(data:{
            titulo: "${editorialInput.titulo}"
            descricao: "${editorialInput.descricao}"
            data: "${editorialInput.data}"
            publicado: N
            autor_id: ${editorialInput.autor_id}
            ativa:S
          }){
            id
            titulo
            descricao
            data
            ativa
            publicado
            autor{
              id
              nome
              foto
            }
            data_publicacao
          }
        }`
      }
    })
  },
  atualizarEditorial: (editorialInput) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarEditorial(id: ${editorialInput.id}, data:{
            titulo: "${editorialInput.titulo}"
            descricao: "${editorialInput.descricao}"
            data: "${editorialInput.data}"
            publicado: N
            autor_id: ${editorialInput.autor_id}
            ativa:S
          }){
            id
            titulo
            descricao
            data
            ativa
            publicado
            autor{
              id
              nome
              foto
            }
            data_publicacao
          }
        }`
      }
    })
  },
  deletarEditorial: (editorialId) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarEditorial(
            id: ${editorialId}
            data: {
              ativa: N
            }
          ){
            id
          }
        }`
      }
    })
  },
  publicarEditorial: (editorialId, data) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarEditorial(
            id: ${editorialId}
            data: {
              ativa: S
              publicado: S
              data_publicacao: "${data}"
            }
          ){
            id
          }
        }`
      }
    })
  },
  despublicarEditorial: (editorialId) => {
    return Vue.prototype.$http("/graphql", {
      data: {
        query: `mutation{
          atualizarEditorial(
            id: ${editorialId}
            data: {
              ativa: S
              publicado: N
            }
          ){
            id
          }
        }`
      }
    })
  },
}
